export type CompanyRole = {
  readonly email: string;
  readonly role?: AgencyRole | AdvertiserRole | ReconciliationRole | BeaconRole;
};

export enum AgencyRole {
  ROLE_AGENCY_ADMIN = 'ROLE_AGENCY_ADMIN',
  ROLE_AGENCY_MANAGER = 'ROLE_AGENCY_MANAGER',
  ROLE_AGENCY_OPERATOR = 'ROLE_AGENCY_OPERATOR',
  ROLE_AGENCY_SALES = 'ROLE_AGENCY_SALES',
  ROLE_AGENCY_REPORT = 'ROLE_AGENCY_REPORT'
}

export enum AdvertiserRole {
  ROLE_ADV_ADMIN = 'ROLE_ADV_ADMIN',
  ROLE_ADV_SALES = 'ROLE_ADV_SALES',
  ROLE_ADV_REPORT = 'ROLE_ADV_REPORT'
}

export enum ReconciliationRole {
  ROLE_RECONCILIATION_OFFICER = 'ROLE_RECONCILIATION_OFFICER'
}

export enum BeaconRole {
  ROLE_BEACON_ADMIN = 'ROLE_BEACON_ADMIN',
  ROLE_BEACON_EXECUTIVE = 'ROLE_BEACON_EXECUTIVE'
}
